import script from "./ReceiveSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReceiveSearch.vue?vue&type=script&setup=true&lang=ts"

import "./ReceiveSearch.vue?vue&type=style&index=0&id=293c2f85&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-293c2f85"]])

export default __exports__